import * as plotlyHuLocale from "plotly.js/lib/locales/hu";

const hu = {
  accept: "Elfogad",
  accessPermissionRequest: "Belépési engedély kérés",
  accountBalance: "Számla egyenleg",
  accountDetails: "Folyószámla részletek",
  accountType: "Számla típusa",
  action: "Tevékenység",
  actionOptions: {
    toServer: "Szerverhez",
    visit: "Látogatás",
    maintenance: "Karbantartás",
    bringsOrTakesServer: "Szervert hoz / visz",
    troubleshooting: "Hibaelhárítás"
  },
  actions: "Műveletek",
  active: "Aktív",
  activeContracts: "Aktív szerződések",
  activeErrorTickets: "Aktív hibajegyek",
  actual: "Aktuális",
  actualNotifications: "Aktuális értesítések",
  add: "Hozzáadás",
  addAnotherContactPerson: "Másik kapcsolattartó hozzáadása",
  addAnotherEntryPerson: "Másik belépő hozzáadása",
  addNewRow: "Új sor hozzáadása",
  addNewVm: "Új VM hozzáadása",
  addToList: "Listához adás",
  addedToDownloadList: "Hozzáadva a letöltés listához.",
  address: "Cím",
  admin: "Admin",
  administration: "Ügyintézés",
  administrationSynonym: "Ügyindítás",
  afType: "AF típus",
  affectedServices: "Érintett szolgáltatások",
  affectedSite: "Érintett telephely",
  affectedSites: "Érintett telephelyek",
  aggregateMode: "Csoportosítási mód",
  agree: "Megértettem",
  all: "Összes",
  allBills: "Összes számla",
  allErrorTickets: "Összes hibajegy",
  allServices: "Összes szolgáltatás",
  allowService: "Szolgáltatás engedélyezve",
  amount: "Összeg",
  another: "További",
  apiErrorMessages: {
    "maintenance/maintenances/*": "Hiba történt a karbantartások betöltése során!",
    "maintenance/service_types": "Hiba történt a karbantartás típusok betöltése során!",
    "maintenance/accept": "Hiba történt a karbantartás elfogadása során!",
    "maintenance/reject": "Hiba történt a karbantartás elutasítása során!",
    "maintenance/contactId/*": "Hiba történt a kapcsolat azonosító betöltése során!",
    "service/*": "Hiba történt a szolgáltatás betöltése során!",
    "company/internalContacts/*": "Hiba történt a kapcsolattartók betöltése során!",
    "ticket/*/contactList": "Hiba történt a kapcsolattartók betöltése során!",
    "service/all/*": "Hiba történt a szolgáltatások betöltése során!",
    "colosite/colo/*": "Hiba történt a szervertermek betöltése során!",
    "colosite/role": "Hiba történt a szintek betöltése során!",
    "colosite/service/*": "Hiba történt a szolgáltatások betöltése során!",
    "colosite/vitrinService/*": "Hiba történt a szolgáltatások betöltése során!",
    "colosite/user/*": "Hiba történt a felhasználók betöltése során!",
    "ticket/*/ticket/list": "Hiba történt a hibajegyek betöltése során!",
    "dms/casetype/list/service": "Hiba történt a ügyek betöltése során!",
    "dms/cases/*": "Hiba történt az ügyek betöltése során!",
    "dms/casetemplate/*": "Hiba történt a ügyintézés mezőinek betöltése során!",
    "dcma/access/*": "Hiba történt a szerverterem belépések betöltése során!",
    "dcma/access": "Hiba történt a szerverterem belépési engedély mentése során!",
    "contract/list/*": "Hiba történt a szerződések betöltése során!",
    "contract/contract/*": "Hiba történt a szerződés részletek betöltése során!",
    "contract/services/*": "Hiba történt a szerződéshez kapcsolódó szerződések betöltése során!",
    "contract/documents/list/*": "Hiba történt a szerződés dokumentumok betöltése során!",
    "contact/edit/selectorlist/*": "Hiba történt a kiválasztó lista betöltése során!",
    "contact/contactperson/new/*": "Hiba történt az új felhasználó adatainak betöltése során!",
    "contact/contactperson/*": "Hiba történt a felhasználó adatainak betöltése során!",
    "contact/contactperson": "Hiba történt a felhasználó adatainak mentése során!",
    "ticket/*/serviceId/openTicket/list": "Hiba történt a nyitott hibajegyek betöltése során!",
    "service/IMPLEMENT/*": "Hiba történt a létesítések betöltése során!",
    "ticket/errormessage/*": "Hiba történt a betöltése során!",
    "ticket/*/saveTicket/": "Hiba történt a jegy beküldése során!"
  },
  applicationGroups: "Alkalmazás csoportok",
  applicationTraffic: "Alkalmazás forgalom",
  applyChanges: "Változtatások érvényesítése",
  attachFiles: "Fájl csatolása",
  attachedMessage: "Csatolt üzenet: ",
  authorizedPerson: "Bejutásra jogosult személy",
  average: "Átlag",
  back: "Vissza",
  backToMainPage: "Vissza a főoldalra",
  balance: "Egyenleg",
  balanceAndCurrentBills: "Egyenleg és folyószámlák",
  bandwidthDown: "Sávszélesség (le)",
  bandwidthUp: "Sávszélesség (fel)",
  bankAccount: "Bankszámlaszám",
  barchart: "Oszlopdiagram",
  beginning: "Kezdete",
  billCollectorId: "Számlagyüjtő azonosító",
  billId: "Számla azonosító",
  billNumber: "Számlaszám",
  billTotal: "Számla végösszege",
  billTypes: {
    bills: "Számla",
    adatkozlo: "Adatközlő",
    calllog: "Hívásrészletező",
    demandletter: "Felszólító levél"
  },
  billing: "Számlázás",
  billingAddress: "Számlaküldés címe",
  billingDate: "Számla kelte",
  bills: "Számlák",
  billsOlderThanTwoYears: "2 éven túli számlájával kapcsolatban kérjük, hogy keresse a vállalati ügyféltámogatást a 1420-as díjmentesen hívható telefonszámon, vagy a corporate@one.hu e-mail címen.",
  buildingVmBottomText: "A folyamat akár több percig is eltarthat, kérjük szíves türelmét!",
  buildingVmCreateTitle: "Létrehozás folyamatban",
  buildingVmList: [
    "CPU-k elhelyezése...",
    "RAM lefoglalása...",
    "Storage beillesztése...",
    "IP lefoglalása...",
    "Domain regisztrálása...",
    "Operációs rendszer telepítése..."
  ],
  buildingVmModifyTitle: "Módosítás folyamatban",
  cancel: "Mégse",
  cannotBeEmpty: "Nem lehet üres!",
  cardList: "Kártyák",
  cartCommentTxt: "Itt jelezheti számunkra a megrendelésével kapcsolatos megjegyzéseit, kéréseit.",
  cartContent: "Kosár tartalma",
  caseId: "Ügy azonosító",
  caseSendError: "ügy beküldése sikertelen",
  caseStartDate: "Ügyindítás dátuma",
  caseType: "Ügy típusa",
  caseUnderRegistration: "Iktatás alatti ügyek",
  category: "Kategória",
  changeLanguage: "Change to English",
  changePassword: "Jelszócsere",
  changePhoto: "Kép cseréje",
  choose: "Kiválasztom",
  chooseCustomerFirst: "Először válasszon ki egy ügyfelet",
  choosePlease: "Kérjük válasszon!",
  choosePreferredPayment: "Válasszon a preferált fizetési módok között",
  chooseRoutersFirst: "Először válassza ki a routereket",
  chooseSitesFirst: "Először válassza ki a telephelyeket",
  classicAccount: "Folyószámla",
  clientCode: "Ügyfélkód",
  clipboardCopySuccessful: "Sikeres vágólapra másolás",
  close: "Bezárás",
  closedCases: "Lezárt ügyek",
  cloud: "Felhő",
  colleagueQuestion: "A kapcsolattartó cégük, intézményük kollégája?",
  comment: "Megjegyzés",
  companyDetails: "Cégadatok",
  companyInformation: "Cégadatok",
  companyInformationSectionTxt: "Adószámának megadásával beazonosítjuk cége további paramétereit",
  companyName: "Cégnév",
  companySelectionError: "Hiba történt a cég kiválasztása során!",
  companySelector: "Cégválasztó",
  companySelectorTitle: "Kérem válasszon az alábbi listából, hogy melyik cég nevében szeretne eljárni!",
  completeSolutions: "Kész megoldások",
  configurator: "Konfigurátor",
  configureMfa: "Kétlépcsős hitelesítés beállítása",
  configureMfaDialog: "Amennyiben aktiválja a kétfaktoros hitelesítést weboldalunkon, kérjük, vegye figyelembe, hogy ezt a beállítást később csak a vállalati ügyféltámogatás (1420) segítségével lehet kikapcsoltatni.",
  configureMfaDialogTitle: "Fontos Biztonsági Információ",
  configureMfaExperimentalFeature: "Kísérleti funkció",
  confirm: "Megerősítés",
  confirmDelete: "Biztosan törölni szeretné?",
  confirmDeleteVm: "Biztosan törölni szeretné a virtuális számítógépet?",
  confirmVmName: "Kérem, erősítse meg a virtuális számítógép nevét az alábbi név begépelésével: ",
  consolePrivilege: "Konzol jogosultság",
  contact: "Kapcsolatfelvétel",
  contactAdditionForVm: "Megkeresés érkezett a(z) $_{name} jelzésű szolgáltatásazonosító kapcsán. ",
  contactData: "Elérhetőségi adatok",
  contactHeader: "Kérem válassza ki a kapcsolatfelvétel tárgyát és írja meg az üzenetet. A bejelentése feldolgozását követően felvesszük Önnel a kapcsolatot!",
  contactHeaderVm: "Kérem a kiválasztott virtuális szerver kapcsán írja meg az igényeit. Az igény feldolgozását követően felvesszük Önnel a kapcsolatot!",
  contactListLoadError: "Hiba történt a kapcsolat lista betöltése során!",
  contactMessageError: "Hiba történt a kapcsolatfelvételi űrlap küldése közben! Kérjük próbálja meg később!",
  contactMsgPlaceholder: "Kérjük ide írja üzenetét (max 2000 karakter)...",
  contactPerson: "Kapcsolattartó",
  contactSuccess: "Köszönjük a megkeresését! Kollégánk hamarosan jelentkezni fog!",
  contacts: "kapcsolattartók",
  contractDetails: "Szerződés részletek",
  contractId: "Szerződés azonosító",
  contractNumber: "Szerződésszám",
  contractTitle: {
    proposal: "Felfüggesztett létesítés szerződések",
    implement: "Létesítés alatti szerződések",
    operating: "Aktív szerződések"
  },
  contractingCompany: "Szerződő cég neve",
  contracts: "Szerződések",
  contractsUnderConstruction: "Létesítés alatti szerződések",
  contractualCurrentAccountNumber: "Szerződéses folyószámla száma",
  cookie: {
    allCookies: "Minden sütit engedélyezek",
    cookieURL: "Tudjon meg többet a sütikről tájékoztatónkból. ",
    headerMessage: "Ez a weboldal sütiket használ",
    mainContentPart1: "Ez az oldal sütiket használ, amelyek elengedhetetlenek a működéséhez, illetve annak érdekében, hogy jobb böngészési élményt nyújtson, személyre szabja a tartalmat, és elemezze a forgalmat. A sütiket elsősorban az oldal üzemeltetője, a forgalom elemzéséhez szükséges sütiket harmadik személy (pl. Google) alkalmazza. ",
    mainContentPart2: "A sütik elfogadásával Ön hozzájárul a nem elengedhetetlen sütik alkalmazásához.",
    requiredCookies: "Csak a szükséges sütiket engedélyezem"
  },
  copyErrorMessage: "Hibaüzenet másolása",
  couldNotDownloadFile: "Hiba a fájl letöltése közben",
  cp: "Ügyfél Portál",
  createNewVm: "Új VM létrehozása",
  creditCard: "Bankkártya",
  cssp: "Felhő Szolgáltatások Önkiszolgáló Portál",
  csspDesc: "Felhő Szolgáltatások Önkiszolgáló Portál",
  currency: "Devizanem",
  currentMaintenances: "Aktuális karbantartások",
  custom: "Egyedi",
  customer: "Ügyfél",
  customerInfo: "Ügyféladatok",
  customerNameAddress: "Vevő neve, címe",
  customerRegistrationNumber: "Cégjegyzékszám",
  dashboard: "Dashboard",
  dataCenter: "Adatközpont",
  dataChange: "Adatváltozás bejelentése",
  dataChangeUser: "Adatok szerkesztése",
  dataTransfer: "Adatátvitel",
  datatable: "Datatable",
  date: "Dátum",
  datePickers: {
    locale: "hu",
    helperText: "éééé.hh.nn",
    timeHelperText: "éééé.hh.nn óó:pp"
  },
  day: "Nap",
  dcArduinoMeter: "DC Arduino Árammérők",
  dcArduinoMeterDesc: "Adatközpontunkban elhelyezett eszközei fogyasztását követheti",
  ddosSecurityService: "DDOS védelem",
  ddosSecurityServiceDesc: "DDOS Szolgáltatások és riasztások megtekintése",
  debtDueAfter8Days: "8 napon túl lejár",
  debtDueWithin8Days: "8 napon belül lejár",
  default: "Default",
  delete: "Törlés",
  deleteConfirm: "Törlés megerősítése",
  deleteContactCustomerService: "Törléshez kérem keresse fel ügyfélszolgálatunkat",
  deleteContactMsg: "Ha kapcsolattartót szeretne törölni, kérjük, hogy keresse a vállalati ügyféltámogatást a 1420-as díjmentesen hívható telefonszámon, vagy a corporate@one.hu e-mail címen.",
  deleteFilters: "Szűrők törlése",
  deleteUserMsg: "Ha felhasználót szeretne törölni kérjük, hogy keresse vállalati ügyféltámogatást a 1420-as díjmentesen hívható telefonszámon, vagy a corporate@one.hu e-mail címen.",
  description: "Leírás",
  details: "Részletek",
  dialog: "Dialog",
  disabledImpersonate: "Megszemélyesítés miatt nem használható",
  dnsManagement: "DNS kezelés",
  dnsManagementDesc: "DNS Zóna kezelés",
  documentNumber: "Okmány száma",
  documentType: "Okmány típusa",
  domain: "Domain",
  domainCounterLoadError: "Hiba történt a domain darabszámának betöltése során!",
  domainExistsError: "Hiba történt a domain létezésének vizsgálata során!",
  domainIncorrectEntry: "Helytelen név.",
  domainListLoadError: "Hiba történt a domain lista betöltése során!",
  domainName: "Domain név",
  domainReserved: "Foglalt név.",
  dontJudge: "Még ne ítélkezz, ez egy work in progress...",
  downloadableDocuments: "Letölthető dokumentumok",
  drivingLicense: "Jogosítvány",
  duration: "Futamidő",
  eBill: "E-számla",
  eNotice: "E-felszólítás",
  eOrder: "E-Megrendelő",
  eOrderSend: "E-Megrendelő beküldése",
  eOrderSendError: "E-megrendelő beküldése sikertelen",
  edit: "Módosítás",
  editSynon: "Szerkesztés",
  editUser: "Felhasználó módosítása",
  email: "E-mail",
  emailAddress: "E-mail cím",
  emailAddressType: "E-mail cím típusa",
  emptyCartHint: "A kosár üres!",
  emptyVmEdit: "Nincs kiválasztva módosítandó virtuális gép!",
  endDate: "Vég dátum",
  endpointAddress: "Végponti cím",
  enterCompanyTaxNumber: "Írja be a cége adószámát",
  enterDate: "Belépés időpontja",
  enterDetails: "Belépés részletei",
  enterInterval: "Belépés intervalluma",
  enterIntervalTooltip: "Egyszeri belépés: minden belépést külön meg kell kérni!",
  entityName: "Entitás név",
  entryInfo: "Bejutási infó",
  error: "Hiba",
  errorButtonInProgress: "A szolgáltatáson folyamatban lévő hibajegy van. A hibajegy lezárásáig nem adható le új hiba",
  errorButtonLimited: "Korlátozott szolgáltatásra nem indíható hibajegy",
  errorButtonSuspend: "Szüneteltetett szolgáltatásra nem indíható hibajegy",
  errorDetails: "Hiba részletei",
  errorMessage: "Hibaüzenet",
  errorMessages: {
    companyListError: "Hiba történt a cégek betöltése során!",
    loadNotificationListError: "Nem sikerült betölteni az értesítés listát",
    notificationCounterLoadError: "Hiba történt az értesítések darabszámának betöltése során!",
    selectedCompanyLoadError: "Hiba történt a kiválasztott cég betöltése során!",
    establishmentCounterLoadError: "Hiba történt a létesítések darabszámának betöltése során!",
    establishmentDataLoadError: "Hiba történt a létesítések betöltése során!",
    userDataLoadError: "Hiba történt a felhasználók betöltése során!",
    billListLoadError: "Hiba történt a számlák betöltése során!",
    billTypesLoadError: "Hiba történt a számla típusok betöltése során!",
    contractsListLoadError: "Hiba történt a szerződések betöltése során!",
    typesLoadError: "Hiba történt a típusok betöltése során!",
    optionsLoadError: "Hiba történt az opciók betöltése során!",
    serviceListLoadError: "Hiba történt a szolgáltatások betöltése során!",
    contractDocumentDownloadError: "Hiba történt a szerződés dokumentum letöltése során!",
    loadingError: "Hiba történt az adatok betöltése során!",
    saveError: "Hiba történt a mentés során!",
    acceptError: "Hiba történt az elfogadás során!",
    rejectError: "Hiba történt az elutasítás során!"
  },
  errorTicket: "Hibajegy",
  errorTicketDetails: "Hibajegy részletes leírása",
  errorTicketId: "Hibajegy azonosító",
  errorTicketListTitle: "A lenti listában azokat a szolgáltatás típusokat listázzuk, amikre hibajegy adható le",
  errorTicketOpenService: "A szolgáltatáson van nyitott hibajegy",
  errorTicketRecording: "Hibajegy felvétel",
  errorTicketSend: "Hibajegy beküldése",
  errorTicketSendError: "Hibajegy beküldése sikertelen",
  errorTicketSender: "Hibajegy feladója",
  errorTooltipMessage: "Kérjük, hogy a hiba pontos behatárolása és elhárítása érdekében adjon meg minden szükséges adatot a szolgálatással és a hibajelenséggel kapcsolatban! Amennyiben nem ad meg elégséges információt, úgy kollégáink keresni fogják Önt a megadott kapcsolattartási csatornák egyikén, hogy a hiba kivizsgálását mihamarabb megkezdhessük. Pl: Adatkapcsolati/internet szolgáltatás: Mit tapasztal pontosan? Teljesen szakadt a szolgáltatás? Az eszközök áram alatt vannak, voltak újraindítva, üzemképesnek tűnnek? Honnan és mit nem ér el pontosan(L3-as szolgáltatás esetén IP-cím)? Ha van tartalék vonal, akkor az működik? Hang/telefon szolgáltatás: Mit tapasztal pontosan? Teljesen néma a vonal? Melyik számot érinti a hiba? Példa hívás: hívószám, hívott szám, hívás időpontja, hibajelenség. IP/internet alapú telefonszolgáltatás esetén a hordozó szolgáltatás üzemel?",
  errorType: "Hiba típusa",
  establishments: "Létesítések",
  euCommunityTaxNumber: "Eu közösségi adószám",
  exhibitionMethod: "Kiállítás módja",
  expectedConstruction: "Várható kiépítés",
  expirationDate: "Lejárat dátuma",
  expirationDateError: "Hiba történt a lejárati dátum betöltése során!",
  expiredNotifications: "Lejárt értesítések",
  exportToExcel: "Exportálás Excel fájlba",
  fastlane: "Fastlane",
  fastlaneDesc: "Kubernetes Fastlane",
  favouriteFood: "Kedvenc étel",
  feedbackDeadline: "Visszajelzés határideje",
  fees: "Díjak",
  fileError: "Hibás fájl",
  fileErrorSize: "Maximum fájl méret 20 MB",
  fileErrorType: "Nem megfelelő fájl. Megfelelő típusok: ",
  fileNotFound: "Nem található a fájl",
  fileUploadTooltip: "Maximális méret: 20 MB. Támogatott fájltípusok: ",
  filter: "Szűrés",
  filterChanged: "A szűrők megváltoztak, kattints az adatok frissítéséhez",
  filters: "Szűrők",
  financialContact: "Ügyfél Portál - Pénzügyi kapcsolattartó",
  financialPartner: "Pénzügyi partner",
  finishedMaintenances: "Elvégzett karbantartások",
  firmwareVersion: "Firmware verzió",
  firstName: "Keresztnév",
  footer: {
    mainPage: {
      mainPageText1: "SZEMÉLYRE SZABOTT MEGOLDÁSOK. PONT ÚGY, AHOGY ÖN SZERETNÉ.",
      askForOffer: "Kérjen ajánlatot most!",
      aboutUs: "Rólunk",
      solutions: "Megoldások",
      socialMedia: "Social-Media",
      aboutInvitech: "A One Solutionsról",
      references: "Referenciák",
      career: "Karrier",
      socialResponsibility: "Társadalmi felelősségvállalás",
      centralizedProcurement: "Központosított beszerzés",
      smartVillage: "Okosfalu",
      forLargeCompanies: "Nagyvállalatoknak",
      forSmallAndMediumCompanies: "Kis és középvállalkozásoknak",
      forInstitutions: "Intézményeknek",
      forWholesalers: "Nagykereskedőknek",
      businessServices: "Vállalati szolgáltatások",
      infrastructureServices: "Infrastruktúra szolgáltatások",
      news: "Hírek",
      press: "Sajtó",
      blog: "Blog",
      loginToCustomerPortal: "Belépés az ügyfélportálra",
      loginToTechnicalPortal: "Belépés a technikai portálra",
      loginToCSSP: "Belépés a Felhő Szolgáltatások Önkiszolgáló Portálra"
    },
    dataProtection: "Adatvédelem",
    dataProcessingCode: "Adatfeldolgozói kódex",
    termsAndConditions: "ÁSZF",
    gtc: "ÁSZF",
    certificates: "Tanúsítványaink",
    impress: "Impresszum",
    providerInformation: "Szolgáltató adatai",
    filteringSoftware: "Szűrőszoftver",
    coServiceOffers: "Társszolgáltatói ajánlatok",
    premiumServices: "Emelt díjas szolgáltatások",
    iivrApplication: "IIVR Pályázat"
  },
  forms: "Űrlapok",
  from: "-tól",
  fromDate: "Dátumtól",
  fulfillmentDate: "Teljesítés dátuma",
  generalSearch: "Általános keresés",
  gift: "ajándék",
  hardwareDeliveryPrivilege: "Hardverelszállítási jogosultság",
  hardwareExchangePrivilege: "Hardvercsere jogosultság",
  hasDuplicateDomainHint: "A megadott domain név többször is szerepel!",
  headquarters: "Székhely",
  help: "Segítség",
  home: "Főoldal",
  homePage: {
    mainTitle: "Állítsa össze saját, bővíthető dedikált szerverét, vagy válasszon a lenti konfigurációkból",
    mainList: [
      "Garantált hibaelhárítás 4 órán belül",
      "Az összeállított konfiguráció bármikor rugalmasan módosítható",
      "Azonnal üzembe helyezhető",
      "Folyamatos biztonsági mentés és monitoring",
      "Saját operációs rendszert futtathat"
    ],
    additionalBenefits: "További előnyök",
    additionalBenefitsCards: {
      card1Title: "Professzionális üzemeltetés",
      card1Text: "Redundáns infrastruktúra, többszörös gerinchálózati adatkapcsolatokkal biztosított internetelérés.",
      card2Title: "Költséghatékony",
      card2Text: "Akár 15-30%-os költségcsökkenést érhet el saját fizikai szerver üzemeltetésével szemben. Havidíjas előfizetés alapú szolgáltatás.",
      card3Title: "Biztonságos",
      card3Text: "Géptermeink a legmagasabb biztonsági szabványoknak is megfelelnek, szerverein tárolt adatai mindig biztonságban lesznek.",
      card4Title: "Egyedi igényre szabható",
      card4Text: "Nem szükséges több évre előre méreteznie szerverét, hiszen üzemeltetési és hardverigényeihez igazodva bármikor növelheti azt."
    },
    selfCareTutorial: "Self Care bemutató",
    theyChoseUs: "Minket választottak",
    theyChoseUsDescription: "Szakértő és tapasztalt partnereként az Ön IT-igényei alapján kínálunk választ egyedi és összetett üzleti kihívásra. Fejlessze IT-rendszerét tudatosan és tervezhetően, kerülje el az egyszeri nagy beruházásokat, béreljen szerver szolgáltatást havidíj alapon."
  },
  hostname: "Hoszt név",
  hour: "Óra",
  huf: "Ft",
  ictSkill: 'ICT jártasság',
  id: "Azonosító",
  idCard: "Személyi igazolvány",
  identificationNumber: "Azonosító száma",
  ifName: "IF Neve",
  inactive: "Inaktív",
  inactiveErrorTickets: "Befejezett hibajegyek",
  interfaceData: "Interface adatok",
  internet: "Internet",
  invalidEmailMsg: "Az email cím nem megfelelő!",
  invalidPhoneNumberMsg: "A telefonszám nem megfelelő!",
  invitation: "Meghívó",
  invitationError: "Hiba történt az email(ek) küldése során!",
  invitationSenderText: "Kérem adja meg, kinek szeretne meghívót küldeni!",
  invitationSuccess: "Sikeres email küldés!",
  invitech: "One Solutions",
  invitechContacts: "One Solutions kapcsolattartók",
  invoiceOutputTypes: {
    REMOTE: "távszámla",
    PAPER: "papír alapú",
    ELECTRO: "elektronikus"
  },
  invoicingAdministration: "Számlázás ügyintézés",
  ipAddress: "IP Cím",
  itPartner: "Informatikai partner",
  itSolutions: "IT megoldások",
  jitter: "Késleltetés ingadozás",
  lastData: "Utolsó adat",
  lastName: "Vezetéknév",
  lastUpdate: "Utolsó frissítés",
  lateFeeInfoUnavailable: "Kedves Ügyfelünk! Késedelmi kamatra vonatkozó információk technikai okokból átmenetileg nem érhetők el a Customer Portál felületén. A késedelmi kamattal növelt fizetendő összegről egyéb ügyfélszolgálati csatornáinkon tájékozódhat. Köszönjük megértését!",
  latency: "Késleltetés",
  later: "Később",
  legalText: {
    prices: "Az árak forintban értendők és az ÁFÁ-t nem tartalmazzák.",
    checkBoxPrimary: "Kérjük, a jelölőnégyzetbe helyezett pipával igazolja, hogy elolvasta, megértette, és elfogadta ",
    checkBoxFirstConjunction: "-ünket és ",
    checkBoxSecondConjunction: "unkat.*"
  },
  level: "Szint",
  licensePlate: "Rendszám",
  licenseType: "Igazolvány típusa",
  linechart: "Vonaldiagram",
  loadingCompanyData: "Cégadatok betöltése",
  loadingList: "Lista betöltés alatt",
  loggedInContact: "Bejelentkezett kapcsolattartó",
  loggingIn: "Bejelentkezés...",
  login: "Belépés",
  loginAndLogout: "Belépés / kilépés",
  logout: "Kijelentkezés",
  logoutDialogContent: "A változtatások érvényesítéséhez kérjük, jelentkezzen be újra.",
  macAddress: "MAC cím",
  mailText: "Az e-mail cím megegyezik a felhasználónévvel",
  maintenance: "Karbantartás",
  maintenanceRejectionConfirm: "Biztos, hogy elutasítja az alábbi karbantartást?",
  maintenanceType: "Karbantartás jellege",
  maintenances: "Karbantartások",
  managerContact: "Ügyfélmenedzser kapcsolatfelvétel",
  manual: "Manuális",
  map: "Térkép",
  masterData: "Törzsadatok",
  masterDataChangeWarning: "A törzsadatok az alábbi ügyfeleknél vannak megadva:\n$_{companyList}.\nMódosítás esetén az itt felsorolt ügyfeleknél is változni fog.",
  materialTable: {
    labelDisplayedRows: "{from}-{to} összesen {count}",
    labelRowsSelect: "sor",
    nRowsSelected: "{0} sor kiválasztva",
    actions: "Műveletek",
    emptyDataSourceMessage: "Nincs megjeleníthető adat",
    filterTooltip: "Szűrő",
    groupingPlaceholder: "Húzd ide a fejlécet...",
    groupedBy: "Csoportosítás: ",
    search: "Keresés"
  },
  max: "Max",
  message: "Üzenet",
  messageSubject: "Bejelentés tárgya",
  mfaDialogContent: {
    text: "A DNS Önkiszolgáló Modul használatához el kell fogadnia az alábbiakat:",
    firstPoint: "(i) Tudomásul veszem és elfogadom, hogy a Modul használata kizárólag a kétfaktoros azonosítással lehetséges (bekapcsolása kötelező)!",
    secondPoint: {
      title: "(ii) Kijelentem, hogy a DNS beállításokkal kapcsolatos kockázatokkal tisztában vagyok és tudomásul veszem, hogy a hibás beállításból eredő rendellenes működésért a Szolgáltató nem felelős!",
      text: "A Modulban a regisztrált előfizetőkhöz tartozó és a rendszerben hozzájuk kapcsolt " +
        "publikus internet domain nevek adminisztrációja végezhető el. Ez magában " +
        "foglalja a DNS rekordok létrehozását, törlését és módosítását. Új zónák " +
        "felvételére, illetve meglévők törlésére az előfizetőnek nincs lehetősége, ezt a " +
        "szolgáltató végzi el. A rendszer alapszintű, elsősorban szintaktikai ellenőrzést " +
        "végez, ezekről visszajelzést ad. Az esetlegesen hibásan elvégzett műveletekből " +
        "fakadó problémák - ami egyebek mellett jelentheti akár egy domain névhez " +
        "kapcsolódó weboldal elérhetetlenségét, vagy a domain névhez kapcsolódó email " +
        "levelezés leállását – az előfizető felelősségi körébe tartoznak.",
      errorContactPrefix: "\n(Hiba észlelése esetén a ",
      errorContactSuffix: " email címen lehet a szolgáltató segítségét igénybe venni)"
    }
  },
  min: "Min",
  minimum3CharactersRequired: "Legalább három karakterre szükség van a keresés elkezdéséhez",
  missingInput: "Hiányzó input mező",
  mobile: "Mobil",
  mobileContactType: "Mobil elérhetőség típusa",
  mobileNumber: "Mobilszám",
  month: "Hónap",
  muiDataTableLocalization: {
    body: {noMatch: "Nincs megjeleníthető adat", toolTip: "Sorbarendezés"},
    pagination: {
      next: "Következő oldal",
      previous: "Előző oldal",
      rowsPerPage: "Sorok oldalanként:",
      displayRows: "/"
    },
    toolbar: {
      search: "Keresés",
      downloadCsv: "Export",
      print: "Nyomtatás",
      viewColumns: "Oszlopok megtekintése",
      filterTable: "Szűrő tábla"
    },
    filter: {all: "Összes", title: "Szűrők", reset: "Alaphelyzetbe állítás"},
    viewColumns: {
      title: "Oszlopok megjelenítése",
      titleAria: "Oszlopok megjelenítése/elrejtése"
    },
    selectedRows: {
      text: "sor kiválasztva",
      delete: "Törlés",
      deleteAria: "Kiválasztott sorok törlése"
    }
  },
  myPermissions: "Jogosultságaim",
  myProfile: "Saját profil",
  name: "Név",
  nameSynonym: "Megnevezés",
  necessaryDocuments: "Szükséges dokumentumok!",
  necessaryDocumentsTooltip: "A következő dokumentum(ok) kitöltése szükséges az ügy indításhoz!",
  needVmForConfigurator: "A konfigurátor működéséhez legalább egy virtuális gépre szükség van",
  newContact: "Új kapcsolattartó",
  newContactToward: "Új kapcsolattartó felvételéhez lépjen át a Szerverterem jogosultságok oldalra!",
  newErrorReport: "Új hibabejelentés",
  newUser: "Új felhasználó",
  newVersionAvailable: "Új verzió érhető el! Kérlek, frissítsd az oldalt!",
  next: "Tovább",
  no: "Nem",
  noAffectedServiceSelected: "Nincs érintett szolgáltatás kiválasztva!",
  noChangesInVm: "Nem történt változtatás a virtuális számítógép beállításaiban",
  noDataToDisplay: "Nincs megjeleníthető adat!",
  noDataWithGivenFilters: "A megadott szűrőkkel nincs elérhető adat",
  noMaintenance: "Jelenleg nincs folyamatban lévő karbantartás",
  noMessageSubjectSelected: "Nincs kiválasztva a bejelentés tárgya!",
  noPageView: "Nincs megfelelő jogosultság az oldal megtekintéséhez!",
  noPayableBill: "Nincs befizetendő számla!",
  noPermission: "Nincs megfelelő jogosultságod!",
  noService: "Nincs szolgáltatás",
  noTaxNumber: "Nincs megadva adószám",
  notFoundLabel: "Az oldal nem található",
  notFoundSubLabel: "Lehet, hogy félreütött vagy időközben megszűnt a keresett oldal. Ellenőrizze az URL címet, vagy válasszon a menüből a továbblépéshez.",
  notSelected: "Nincs kiválasztva",
  notice: "Tájékoztató",
  notifications: "Értesítések",
  object: "Objektum",
  offers: "Ajánlatok",
  onSiteContact: "Helyszíni kapcsolattartó",
  onSiteContactEmail: "Helyszíni kapcsolattartó e-mail",
  onSiteContactName: "Helyszíni kapcsolattartó neve",
  onSiteContactPhoneNumber: "Helyszíni kapcsolattartó telefonszáma",
  operatingSystem: "Operációs rendszer",
  operatingSystemShort: "Op. rendszer",
  operationCannotBeUndone: "A művelet nem visszavonható!",
  operativePartner: "Operatív partner",
  optionalOpSystem: "Szabadon választható op. rendszer",
  order: "Megrendelés",
  orderLoadError: "Hiba történt a rendelés betöltése során!",
  orderSaveError: "Hiba történt a rendelés mentése során!",
  osListLoadError: "Hiba történt az operációs rendszerek betöltése során!",
  other: "Egyéb",
  otherServiceParameters: "Szolgáltatás egyéb paraméterei",
  overdueDebt: "Lejárt tartozás",
  overviewOfEstablishments: "Létesítések áttekintése",
  overviewOrderProducts: "Megrendelendő termékek áttekintése",
  packetLoss: "Csomagvesztés",
  pageNotFound: "Az oldal nem található",
  pageNotFoundLong: "Sajnáljuk, a keresett oldalt sajnos nem találjuk",
  paid: "Fizetett",
  paperBase: "Papír alapú",
  passport: "Útlevél",
  payable: "Fizetendő",
  paymentDate: "Befizetés dátuma",
  paymentDeadline: "Fizetési határidő",
  paymentDetails: "Fizetési adatok",
  paymentMethod: "Fizetés módja",
  pendingCases: "Folyamatban lévő ügyek",
  percentage: "Százalék",
  performanceMonitor: "Performancia monitor",
  performanceMonitorDesc: "Hálózati és más eszközök teljesítménygrafikonjait megjelenítő eszköz",
  period: "Időszak",
  periodEnd: "Időszak vége:",
  permissionDenied: "Hozzáférés megtagadva",
  permissionDeniedMsg: "Nincs jogosultsága a kért tartalom megtekintéséhez. Kérem menjen vissza az előző vagy a főoldalra.",
  permissionPrivilege: "Engedélyezési jogosultság",
  personalData: "Személyes adatok",
  phone: "Telefon",
  phoneNumber: "Telefonszám",
  phoneNumberHelperTxt: "+<országkód> <körzet> <telefonszám>",
  phoneNumberType: "Telefonszám típusa",
  pleaseWait: "Kérem várjon...",
  plotlyLocale: {
    locales: {"hu": plotlyHuLocale},
    locale: "hu"
  },
  portId: "Port azonosító",
  portalAccess: "Portál hozzáférés",
  position: "Pozíció",
  positions: {
    ceo: "CEO",
    cio: "CIO",
    cto: "CTO",
    ciso: "CISO",
    cfo: "CFO",
    staff: "Staff"
  },
  post: "Beosztás",
  previousMaintenance: "Korábbi karbantartások",
  privacyPolicy: "Adatvédelmi Szabályzat",
  privilegeLevels: "Jogosultsági szintek",
  privilegeLevelsLocalization: {
    admin: "Teljes jogkörrel rendelkezik.",
    all: "Minden felhasználó eléri a \"Támogatás\", \"Értesítések\" \"Cégadatok\" menüpontokat, a \"Felhasználói profil\"-ját és a híreinket.",
    consolePrivilege: "Távoli eléréssel veheti át a Megrendelő szerverét, fizikailag azonban nem férhet hozzá.",
    financialPartner: "Intézheti hibabejelentéseiket, ügyfélszolgálati ügyeiket, megtekintheti szolgáltatásaikat.",
    hardwareDeliveryPrivilege: "Jogosult az eszköz elvitelére, emellett Konzol és Hardvercsere hozzáférési joggal is rendelkezik. (A Szolgáltató tulajdonát képező bérelt szerverre ez nem vonatkozik!)",
    hardwareExchangePrivilege: "Konzol jogosultság mellett jogosult a szervert egy kijelölt helyiségbe kikérni, javítási munkákat végezhet. (A Szolgáltató tulajdonát képező bérelt szerverre ez nem vonatkozik!)",
    itPartner: "Felhasználói regisztráción kívül minden funkcióhoz van hozzáférése.",
    financialContact: "Megtekintheti a számlázási és szerződéses információkat, intézheti ügyfélszolgálati ügyeiket.",
    technicalContact: "Intézheti hibabejelentéseiket, ügyfélszolgálati ügyeiket, megtekintheti szolgáltatásaikat."
  },
  profile: "Profil",
  pushMe: "Nyomj meg!",
  range: "Intervallum",
  refresh: "Frissítés",
  registeringCourt: "Nyilvántartásba bejegyző bíróság",
  registrationForFreeIceCream: "Regisztráció ingyen fagyira",
  registrationNumber: "Cégjegyzék szám",
  reject: "Elutasít",
  rejectMaintenance: "Karbantartás elutasítása",
  rejectReason: "Elutasítás indoka",
  relatedBills: "Kapcsolódó számlák",
  relatedErrorTickets: "Kapcsolódó hibajegyek",
  relatedServices: "Kapcsolódó szolgáltatások",
  relatedServicesChange: "Összekapcsolt szolgáltatás ID",
  relatedServicesID: "Kapcsolodó szolgáltatás azonosító",
  relatedSite: "Felszerelési cím",
  remoteAccount: "Távszámla",
  reportDate: "Bejelentés dátuma",
  reportEndDate: "Lezárás dátuma",
  reportedAsErrorTicket: "Hibajegyre jelentve",
  reporterName: "Bejelentő neve",
  requestForOffer: "Ajánlatkérés",
  requestForOfferInProgress: "Ajánlatkérés folyamatban",
  requiredPaymentDetails: "A megrendeléshez a cég és a fizetési adatok is szükségesek",
  reservedDomainHint: "Foglalt vagy hibás domain(ek) lett(ek) megadva!",
  rights: "Jogosultságok",
  role: "Szerepkör",
  roles: {
    admin: "Admin",
    finance: "Pénzügyi kapcsolattartó",
    technical: "Technikai kapcsolattartó"
  },
  routerName: "Router megnevezés",
  routerSerialNumber: "Router sorozatszám (S/N)",
  routerType: "Router típus",
  save: "Mentés",
  scheduled: "Ütemezett",
  scheduledLoginLogout: "Igényelt belépés és kilépés",
  sdWanDesc: "SD-WAN szolgáltatás áttekintésére szolgáló felület",
  sdWanId: "SD-WAN azonosító",
  sdwanSites: "SD-WAN Telephelyek",
  selectObjects: "Válasz ki az objektumokat",
  send: "Küldés",
  sendInvitation: "Meghívó küldés",
  sendRequest: "Bejelentés elküldése",
  sendRequestForOffer: "Ajánlatkérés elküldése",
  senderDetails: "Feladó adatai",
  serverName: "Szerver neve",
  serverRoom: "Szerverterem",
  serverRoomAccess: "Szerverterem belépések",
  serverRoomAccessPermit: "Szerverterem belépési engedély",
  serverRoomAccesses: "Szerverterem belépések",
  serverRoomPermissions: "Szerverterem jogosultságok",
  service: "Szerviz",
  serviceAddress: "Szolgáltatási cím",
  serviceAdministration: "Szolgáltatás ügyintézés",
  serviceCategories: {
    internet: "Adat és internet szolgáltatások",
    dataCenter: "Adatközponti szolgáltatások",
    other: "Egyéb szolgáltatások",
    cloud: "Felhő szolgáltatások",
    office: "Irodai informatikai rendszerek",
    security: "IT biztonsági szolgáltatások",
    communication: "Telefon- és kommunikációs szolgáltatások"
  },
  serviceError: "Szolgáltatás hibája",
  serviceId: "Szolgáltatás azonosító",
  serviceParameters: "A szolgáltatás paraméterei",
  serviceRelatedNotification: "Szolgáltatással kapcsolatos értesítés",
  serviceStatus: "Szolgáltatás státusz",
  serviceSynonym: "Szolgáltatás",
  serviceType: "Szolgáltatástípus",
  services: "Szolgáltatások",
  setting: "Beállítás",
  settings: "Beállítások",
  shId: "SH azonosító",
  showAllVms: "Összes VM megtekintése",
  showApplicationTraffic: "Alkalmazás forgalom megjelenítése",
  showCode: "Mutasd a kódot",
  showInterfaceData: "Interface adatok megjelenítése",
  showLineBreaks: "Sortörések mutatása",
  showSiteDetails: "Telephely részletek megjelenítése",
  showTrafficData: "Forgalmi adatok megjelenítése",
  signatureDate: "Aláírás dátuma",
  site: "Telephely",
  siteAddress: "Telephely cím",
  siteOrder: "Telephely sorszám",
  sites: "Telephelyek",
  soc: "SOCaaS",
  socDesc: "A Security Operations Center (SOC) szolgáltatás 7/24-es monitorozást és aktív biztonsági észlelést és kezelést biztosít.",
  solution: {
    forGeneralBusinessUse: "általános üzleti használathoz",
    forHighComputingNeeds: "nagy számítási igényekhez",
    forMediumComputingNeeds: "közepes számítási igényekhez",
    toHostLargeContent: "nagy méretű tartalmak hosztolásához",
    customVmDescription: "egyedi igényekhez egyedi konfiguráció"
  },
  solutionListLoadError: "Hiba történt az megoldások betöltése során!",
  solutions: "Megoldások",
  sortByDate: "Sorbarendezés dátum szerint",
  sound: "Hang",
  speedMbps: "Sebesség (MBPS)",
  ssoRolesTooltip: "További felhasználók regisztrálásával kapcsolatban kérjük keresse Ügyfélszolgálatunkat.",
  starWarsMovies: "Star Wars filmek",
  startDate: "Kezdeti dátum",
  startDateSynonym: "Indulás dátuma",
  status: "Státusz",
  statusChangeDate: "Státuszváltás dátuma",
  statusError: "Státusz: Hiba",
  statusOk: "Státusz: OK",
  statusSynonym: "Állapot",
  statusUnknown: "Státusz: Ismeretlen",
  statusWarning: "Státusz: Figyelmeztetés",
  storage: "Tárhely",
  storageType: "Tárhely típus",
  storageTypeListLoadError: "Hiba történt a tárhely típusok betöltése során!",
  successCaseStart: "Sikeres ügyindítás",
  successCreate: "Sikeres létrehozás",
  successDelete: "Sikeres törlés",
  successEOrderSend: "Sikeres e-megrendelés",
  successEdit: "Sikeres módosítás",
  successErrorTicketSend: "Sikeres hibajegy felvétel",
  successVmCreateTitle: "Sikeres VM létrehozás",
  successVmDeleteTitle: "Sikeres VM törlés",
  successVmEditTitle: "Sikeres VM módosítás",
  successfulAcceptance: "Sikeres elfogadás",
  successfulEntry: "Sikeres bejegyzés",
  successfulModification: "Sikeres módosítás",
  successfulRejection: "Sikeres elutasítás",
  summary: "Összegzés",
  support: "Támogatás",
  suspendedEstablishmentContracts: "Felfüggesztett létesítés szerződések",
  taxNumber: "Adószám",
  technicalBackground: "Műszaki háttér",
  technicalContact: "Ügyfél Portál - Technikai kapcsolattartó",
  technicalId: "Műszaki azonosító",
  technicalOverview: "Műszaki áttekintés",
  technical_support: "Támogatás",
  testPeriod: "Teszt időszak",
  timeSelectorOptions: {s: "mp", m: "p"},
  to: "-ig",
  toDate: "Dátumig",
  tooLongName: "A megadott név túl hosszú!",
  tooLongNote: "A megjegyzés túl hosszú!",
  tooManyVmAndReservedDomainHint: "Elérte a max. VM számot ($_{count} db) és foglalt vagy hibás domain(ek) lett(ek) megadva!",
  tooManyVmHint: "Elérte a max. VM számot ($_{count} db)!",
  total: "Végösszeg",
  totalDebt: "Összesen fizetendő",
  tp: "Technical Portal",
  traffic: "Forgalom",
  trafficData: "Forgalmi adatok",
  transfer: "Átutalás",
  trialTimeExpire: "Teszt időszak vége: ",
  tryIt: "Kipróbálom",
  type: "Típus",
  underAssignment: "Kiosztás alatt",
  underConstruction: "Létesítés alatt",
  uniqueOffer: "egyedi ajánlat",
  unknownAddress: "Ismeretlen cím",
  unknownError: "Ismeretlen hiba",
  unpaidBills: "Fizetendő számlák",
  uploadFiles: "Fájlok feltöltése",
  user: "Felhasználó",
  userData: "Felhasználói adatok",
  users: "Felhasználók",
  usersAndPermissions: "Felhasználók és jogosultságok",
  validity: "Érvényesség",
  version: "Verzió",
  virtualMachine: "Virtuális számítógép",
  virtualMachineChange: "Virtuális számítógép módosítás",
  virtualMachineName: "Virtuális számítógép neve",
  virtualMachineOrder: "Virtuális számítógép megrendelés",
  virtualServer: "Virtuális szerver",
  virtualServerDashboard: "Virtuális szerver dashboard",
  virtualServerVm: "Virtuális szerver (VM)",
  vmConfigurator: "VM Konfigurátor",
  vmCounterLoadError: "Hiba történt a vm darabszámának betöltése során!",
  vmCreateInProgressText: "A kért művelet az átlagosnál több időt vesz igénybe, ezért még egy kis türelmét kérjük. Nem szeretnénk tovább várakoztatni, ezért ezt az ablakot nyugodtan bezárhatja, e-mailben azonnal értesítjük, amint elkészülünk.",
  vmCreateInProgressTitle: "VM létrehozása folyamatban",
  vmDeleteError: "Hiba történt a vm törlése során!",
  vmEditInProgressTitle: "VM módosítása folyamatban",
  vmInProgressError: "Folyamatban lévő művelet!",
  vmListLoadError: "Hiba történt a vm lista betöltése során!",
  vmLoadError: "Hiba történt a vm betöltése során!",
  vmNameChangeError: "Hiba történt a VM név módosítása során!",
  vmNameChangeSuccess: "Sikeres VM név módosítás",
  vmTemplateLoadError: "Hiba történt a vm részleteinek betöltése során!",
  vmUpdateError: "Hiba történt a vm módosítása során!",
  voice: "Hang",
  week: "Hét",
  whichCompanyComeFromQuestion: "Melyik cégtől érkezik?",
  workLog: "Munkanapló",
  yes: "Igen"
};

export default hu;
